<template>
  <div class="user_all" v-loading="fullscreenLoading">
    <div class="user_search" style="display:flex;align-items:center">
      <span style="width: 100px;display: inline-block">{{ $t('title.RPC_service') }}：</span>
      <el-select style="width: 250px" v-model="selectRpc" @change="changeRpc()" placeholder="RPC服务">
        <el-option
          v-for="item in optionRpc"
          :key="item.rpcUrl"
          :label="item.name"
          :value="item.rpcUrl"
        ></el-option>
      </el-select>
      <span style="width: 100px;display: inline-block"></span>
      <el-select
        style="width: 250px"
        v-model="selectChain"
        @change="changeChain()"
        :placeholder="$t('title.Please_select_the_chain')"
      >
        <el-option v-for="item in optionsChain" :key="item" :label="item+$t('title.chain')" :value="item"></el-option>
      </el-select>
      <p style="margin-left:auto">000000000000000000</p>
    </div>
    <div class="user_search">
      <span style="width: 100px;display: inline-block">{{ $t('title.Contract_name') }}：</span>
      <el-input type="primary" style="width: 30%;" :placeholder="this.$t('title.Please_enter_the_contract_name')" v-model="contractName"></el-input>
    </div>
    <div class="user_search">
      <span style="width: 100px;display: inline-block">{{ $t('title.publisher') }}：</span>
      <el-select style="width: 250px" v-model=" selectUser" :placeholder="this.$t('title.please_choose')" @change="changepeo">
        <el-option
          v-for="item in optionUser"
          :key="item.id"
          :label="`${item.nickname} - ${item.address}`"
          :value="item.address"
        ></el-option>
      </el-select>
      <span style="display: inline-block;margin-left: 30px">{{ $t('title.Balance') }}：</span>
      <span style="display: inline-block;margin-left: 10px">{{peonum}}</span>
      <span style="display: inline-block;margin-left: 30px">{{ $t('title.address') }}：</span>
      <span style="display: inline-block;margin-left: 10px">{{address}}</span>
    </div>
    <div class="user_search">
      <span style="width: 100px;display: inline-block">{{ $t('title.Contract_template') }}：</span>
      <el-select
        style="width: 250px"
        v-model="selectConTem"
        :placeholder="this.$t('title.please_choose')"
        @change="contractChange"
      >
        <el-option v-for="item in optionConTem" :key="item.id" :label="item.name" :value="item.id"></el-option>
      </el-select>
      <el-button style="margin-left:10px" type="text" @click="opendialog(1)">{{ $t('title.Add_to') }}</el-button>
      <el-button type="text" @click="opendialog(2)">{{ $t('title.Revise') }}</el-button>
      <!-- 添加/修改模板弹框 -->
      <el-dialog
        :title="type==1 ? this.$t('title.NewaddContract_template'): this.$t('title.ReviseContract_template') "
        :visible.sync="dialogVisible"
        width="50%"
        :before-close="handleClose"
        :close-on-click-modal="false"
      >
        <div class="contract_form">
          <el-form label-position="right" label-width="100px">
            <el-form-item label="是否公开:">
              <el-switch v-model="contractForm.publicFlag"></el-switch>
            </el-form-item>
            <el-form-item :label="this.$t('title.Contract_name')+':'">
              <el-input style="width:30%" v-model="contractForm.name"></el-input>
            </el-form-item>
            <el-form-item label="合约描述:">
              <el-input style="width:30%" v-model="contractForm.description"></el-input>
            </el-form-item>
            <el-form-item label="版本号:">
              <el-input style="width:30%" v-model="contractForm.version"></el-input>
            </el-form-item>
            <el-form-item label="构造函数参数:" v-if="type == 2">
              <el-input style="width:30%" v-model="contractForm.constructorParam"></el-input>
              <el-button
                @click="addFunParams"
                style="margin-left:20px"
                type="primary"
                icon="el-icon-plus"
                circle
              ></el-button>
            </el-form-item>
            <div
              v-for="item in contractForm.contractFuncVoList"
              :key="item.id"
              style="margin-bottom:20px"
              v-if="type == 2"
            >
              <el-input
                placeholder="方法名称"
                style="width:20%;margin-right:10px"
                v-model="item.funcName"
              ></el-input>
              <el-select style="width:20%;margin-right:10px" v-model="item.type" placeholder="合约类型">
                <el-option label="合约交易" :value="1"></el-option>
                <el-option label="合约调用" :value="0"></el-option>
              </el-select>
              <el-input
                :placeholder="this.$t('title.Method_entry')"
                style="width:20%;margin-right:10px"
                v-model="item.funcParam"
              ></el-input>
              <el-input
                placeholder="方法出参"
                style="width:20%;margin-right:10px"
                v-model="item.funcOutParam"
              ></el-input>
              <el-button @click="delFunParams(item.id)" type="danger" icon="el-icon-delete" circle></el-button>
            </div>
          </el-form>
          <el-form
            label-position="right"
            label-width="100px"
            style="border-top:1px solid #ccc;padding-top:20px;"
          >
            <el-form-item>
              <el-radio v-model="fileType" label="1">源代码</el-radio>
              <el-radio v-model="fileType" label="2">abi</el-radio>
           </el-form-item>
            <p style="color:red">主合约名称定义请参考"SDK下载 -> 平台使用教程"</p>
            <template v-if="fileType == 1" v-for="item in solContentData">
              <el-form-item label="主合约名称:">
                <el-input v-model="item.name" style="width:30%;"></el-input>
                <el-button
                  @click="addFile"
                  style="margin-left:20px"
                  type="primary"
                  icon="el-icon-plus"
                  circle
                ></el-button>
                <el-button @click="delFile(item.id)" type="danger" icon="el-icon-delete" circle></el-button>
              </el-form-item>
              <el-form-item label="文件内容:">
                <el-input
                  :autosize="{ minRows: 6, maxRows: 6}"
                  type="textarea"
                  v-model="item.content"
                  style="width:80%;"
                ></el-input>
              </el-form-item>
            </template>
            <el-form-item v-if="fileType == 2" label="文件内容:">
              <el-input
                :autosize="{ minRows: 6, maxRows: 6}"
                type="textarea"
                v-model="contractForm.abiJson"
                style="width:80%;"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="handleClose">{{ $t('title.Cancel') }}</el-button>
          <el-button type="primary" @click="submitConTem">{{ $t('title.Sure') }}</el-button>
        </span>
      </el-dialog>
    </div>
    <div class="user_search" style="display:flex;" v-if="constructorParam">
      <label style="line-height:40px;">构造函数：</label>
      <div style="display:inline-block">
        <div
          v-for="(item, index) in constructorParam.split(',')"
          :key="item"
          style="margin-bottom:10px"
        >
          <label style="display:inline-block;width:120px;">{{item.split(' ')[1]}}：</label>
          <el-input
            v-model="param[index]"
            type="primary"
            style="width: 250px;margin-right:10px;"
            :placeholder="item.split(' ')[0]"
          ></el-input>
        </div>
      </div>
    </div>
    <div class="user_search">
      <span style="width: 100px;display: inline-block">{{ $t('title.Remark') }}：</span>
      <el-input type="primary" style="width: 30%;" :placeholder="this.$t('title.Please_enter_a_note')" v-model="noteValue"></el-input>
      <el-button type="primary" style="margin-left: 50px" @click="releaseContract">{{ $t('title.release') }}</el-button>
    </div>
    <div class="user_search" style="float: right">
      <el-button
        v-if="roles.roleId < 10000"
        type="primary"
        style="margin-left: 30px"
        @click="syncXinkes"
      >同步芯客</el-button>
      <el-button type="primary" style="margin-left: 30px" @click="searAdd()">{{ $t('title.Refresh') }}</el-button>
    </div>
    <div class="con_table">
      <el-table
        :data="tableData"
        height="520"
        border
        style="width: 100%;margin-bottom: 30px;margin-top: 40px;"
        :header-cell-style="this.tableHeaderColor"
      >
        <el-table-column :label="this.$t('title.Serial_number')" fixed align="center" width="90">
          <template slot-scope="scope">
            <span>{{scope.row.id}}</span>
          </template>
        </el-table-column>
        <el-table-column :label="this.$t('title.Publish_hash')" width="400" align="center">
          <template slot-scope="scope">
            <el-link
              @click="$refs.searchHash.open(scope.row.hash, scope.row.rpcServer, scope.row.chainId)"
              :underline="false"
              type="primary"
            >{{scope.row.hash}}</el-link>
          </template>
        </el-table-column>
        <el-table-column :label="this.$t('title.Contract_name')" width="150" align="center">
          <template slot-scope="scope">
            <span>{{scope.row.contractName}}</span>
          </template>
        </el-table-column>
        <el-table-column :label="this.$t('title.Contract_template')" width="150" align="center">
          <template slot-scope="scope">
            <span>{{scope.row.contractId}}</span>
          </template>
        </el-table-column>
        <el-table-column :label="this.$t('title.Contract_address')" width="400" align="center">
          <template slot-scope="scope">
            <span>{{scope.row.contractAddress}}</span>
            <br />
            <span>{{to_32_decimal(scope.row.contractAddress)}}</span>
          </template>
        </el-table-column>
        <el-table-column :label="this.$t('title.RPC_service')" width="200" align="center">
          <template slot-scope="scope">
            <span>{{scope.row.rpcServer}}</span>
          </template>
        </el-table-column>
        <el-table-column :label="this.$t('title.Chain_id')" width="150" align="center">
          <template slot-scope="scope">
            <span>{{scope.row.chainId}}</span>
          </template>
        </el-table-column>
        <el-table-column :label="this.$t('title.Publisher_address')" width="400" align="center">
          <template slot-scope="scope">
            <span>{{scope.row.address}}</span>
            <br />
            <span>{{to_32_decimal(scope.row.address)}}</span>
          </template>
        </el-table-column>
        <el-table-column :label="this.$t('title.TKM_before_launch')" width="150" align="center">
          <template slot-scope="scope">
            <span>{{scope.row.userBeforeCoins}}</span>
          </template>
        </el-table-column>
        <el-table-column :label="this.$t('title.Post_launch_TKM')" width="150" align="center">
          <template slot-scope="scope">
            <span>{{scope.row.userAfterCoins}}</span>
          </template>
        </el-table-column>
        <el-table-column :label="this.$t('title.Gas_fee')" width="150" align="center">
          <template slot-scope="scope">
            <span>{{scope.row.gasFee}}</span>
          </template>
        </el-table-column>
        <el-table-column :label="this.$t('title.release_time')" width="200" align="center">
          <template slot-scope="scope">
            <span>{{timestampToTime(scope.row.createTime)}}</span>
          </template>
        </el-table-column>
        <el-table-column :label="this.$t('title.Balance')" width="150" align="center">
          <template slot-scope="scope">
            <span>{{scope.row.coins}}</span>
          </template>
        </el-table-column>
        <el-table-column :label="this.$t('title.state')" width="150" fixed="right" align="center">
          <template slot-scope="scope">
            <span
              :style="scope.row.status==0?'color:red':'color:green'"
            >{{scope.row.status==0?'已下架':scope.row.status==-1?'已发送待验证':'已发布'}}</span>
            <!--                        -->
          </template>
        </el-table-column>
        <el-table-column :label="this.$t('title.Remark')" width="180" fixed="right" align="center">
          <template slot-scope="scope">
            <span>{{scope.row.description}}</span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        @current-change="currentPageChange"
        :current-page="currentPage"
        :page-size="10"
        layout="total,prev, pager, next"
        :total="total"
      ></el-pagination>
      <!-- 交易查询结果 -->
      <el-dialog title="hash查询结果" :visible.sync="hahsDialogVisible" width="70%">
        <json-view :data="returnHash" />
        <span slot="footer" class="dialog-footer">
          <el-button @click="hahsDialogVisible = false">{{ $t('title.Cancel') }}</el-button>
          <el-button type="primary" @click="hahsDialogVisible = false">{{ $t('title.Sure') }}</el-button>
        </span>
      </el-dialog>
      <SearchHash ref="searchHash" />
    </div>
  </div>
</template>

<script>
import {
  getrpcserver,
  getchaininfo,
  contractList,
  contractDeploy,
  userlList,
  usercontract,
  transferList,
  getaccount,
  syncXinke,
  addContract,
  updateContract,
} from "../../../api/interface";
import { mapState } from "vuex";
import shortid from "shortid";
import SearchHash from "../../SearchHash";
export default {
  name: "Contract",
  components: { SearchHash },
  data() {
    return {
      isResponse: false,
      selectRpc: "",
      seleArr: [],
      optionRpc: [],
      selectChain: "",
      optionsChain: [],
      inputValue: "",
      optionContract: [],
      selectContract: "",
      selectConTem: "",
      optionConTem: [],
      funcValue:
        '{"_tokenSymbol": "GAN","_tokenName": "GAN","_decimalUnits": "18","_initialAmount":"10000"}',
      noteValue: "",
      fullscreenLoading: false,
      optionUser: [],
      selectUser: "",
      tableData: [],
      peonum: "",
      contractName: "",
      address: "",
      dialogVisible: false,
      hahsDialogVisible: false,
      contractForm: {
        publicFlag: false,
        contractJson: "{}",
        name: "",
        description: "",
        version: "",
        constructorParam: "",
        solContent: "",
        abiJson: "",
        contractFuncVoList: [
          {
            id: shortid.generate(),
            funcName: "transfer",
            type: "",
            funcParam: "address:account",
            funcOutParam: "",
          },
        ],
      },
      solContentData: [
        {
          id: 0,
          name: "",
          content: "",
        },
      ],
      returnHash: {},
      type: "",
      constructorParam: "",
      param: [],
      currentPage: 1,
      total: 0,
      fileType: "1",
    };
  },
  activated() {
    this.searAdd();
  },
  methods: {
    searAdd() {
      const data = {
        page: this.currentPage,
        rows: 10,
      };
      usercontract(data).then((response) => {
        this.tableData = response.data.data;
        this.total = response.data.total;
      });
    },
    syncXinkes() {
      this.Loading = true;
      syncXinke().then((res) => {
        if (res.code == 200) {
          this.Loading = false;
          this.$message.success(res.msg);
        }
      });
    },
    changepeo() {
      const data = {
        address: this.selectUser,
        chainId: this.selectChain,
        rpcServer: this.selectRpc,
      };
      getaccount(data).then((res) => {
        console.log(res, 111111);
        this.peonum = res.data.balanceValue;
        this.address = res.data.address;
      });
    },
    getUser() {
      let data = {
        rpcServer: this.selectRpc,
        chainId: this.selectChain,
        address: "",
        page: 1,
        rows: 10000,
      };
      userlList(data).then((response) => {
        this.fullscreenLoading = false;
        this.selectUser = "";
        if (response.code == 200) {
          this.optionUser = response.data.data;
          this.selectUser = this.optionUser[0].address;
          this.peonum = this.optionUser[0].coins;
          this.address = this.optionUser[0].address;
        } else {
          this.optionUser = [];
          this.$message.error(response.msg);
        }
      });
    },
    releaseContract() {
      // if (this.funcValue == "") {
      //   this.$message.error("请输入构造函数！");
      //   return;
      // }
      // if (!this.contractName) {
      //   this.$message.error("请输入合约名称！");
      //   return;
      // }
      // if (this.peonum < 0) {
      //   this.$message.error("发布合约，余额至少1TKM，用于Gas费！");
      //   return;
      // }

      // 去空格 转逗号
      let params = {};
      if (this.param) {
        this.param.forEach((v, index, arr) => {
          arr[index] = arr[index].replace(/\s*/g, "").replace(/，/g, ",");
        });
        console.log(this.param, 100002)
        const arr = this.constructorParam.split(",");
        for (let i = 0; i < arr.length; i++) {
          if(arr[i].split(" ")[0].includes('[')) {
            if(this.param[i].includes(',')) {
              params[arr[i].split(" ")[1]] = this.param[i].split(',')
            }else {
               params[arr[i].split(" ")[1]] = [this.param[i]]
            }
           
          } else {
            params[arr[i].split(" ")[1]] = this.param[i];
          }
          
        }
        params = JSON.stringify(params);
      } else {
        params = "";
      }
      let data = {
        address: this.selectUser,
        contractId: this.selectConTem,
        rpcServer: this.selectRpc,
        chainId: this.selectChain,
        description: this.noteValue,
        params,
        contractName: this.contractName,
      };
      this.fullscreenLoading = true;
      contractDeploy(data).then((response) => {
        this.fullscreenLoading = false;
        if (response.code == 200) {
          this.$message.success("Success！");
          this.currentPage = 1;
          this.searAdd();
        } else {
          this.$message.error(response.msg);
        }
      });
    },
    changeRpc() {
      this.fullscreenLoading = true;
      let data = { rpcServer: this.selectRpc };
      getchaininfo(data).then((response) => {
        this.optionsChain = response.data;
        this.selectChain = this.optionsChain[0];
        this.getUser();
      });
    },
    changeChain() {
      this.fullscreenLoading = true;
      this.getUser();
    },
    getData() {
      getrpcserver().then((response) => {
        this.fullscreenLoading = true;
        this.optionRpc = response.data;
        this.selectRpc = this.optionRpc[0].rpcUrl;
        let data = { rpcServer: this.optionRpc[0].rpcUrl };
        getchaininfo(data).then((response) => {
          this.optionsChain = response.data;
          this.selectChain = this.optionsChain[0];
          this.getUser();
        });
      });
      this.getContractList();
    },
    getContractList() {
      contractList().then((response) => {
        if (response.code == 200) {
          this.optionConTem = response.data;
          this.selectConTem = this.optionConTem[0].id;
          // replace(/  */g," ")

          this.constructorParam =
            response.data &&
            response.data[0].constructorParam.replace(/  */g, " ");
        } else {
          this.optionConTem = [];
          this.$message.error(response.msg);
        }
      });
    },

    //打开编辑合约模板
    opendialog(type) {
      this.dialogVisible = true;
      this.type = type;
      //编辑回显
      if (type == 2) {
        const editData = this.optionConTem.find(
          (v) => v.id == this.selectConTem
        );
        const {
          userId,
          status,
          createTime,
          contractNo,
          updateTime,
          ...data
        } = editData;
        if (userId == 0) {
          data.publicFlag = true;
        } else {
          data.publicFlag = false;
        }
        //解析源代码字符串
        const obj = JSON.parse(data.solContent);
        console.log(obj, 90000);
        const solContentData = [];
        for (let item in obj) {
          solContentData.push({
            id: Date.now(),
            name: item,
            content: obj[item],
          });
        }
        this.solContentData = solContentData;
        console.log(data, 9292992992);

        //回显判断走源代码还是abi
        if (data.contractJson) {
          const abiJsonObj = JSON.parse(data.contractJson);
          const abiJson = abiJsonObj.abi;
          this.contractForm.abiJson = abiJson;
          this.fileType = "2";
        } else {
          this.fileType = "1";
        }

        this.contractForm = { ...this.contractForm, ...data };
        console.log(this.contractForm, 9000021);
      }
    },
    //添加文件
    addFile() {
      this.solContentData.push({
        id: Date.now(),
        name: "",
        content: "",
      });
    },
    delFile(id) {
      this.solContentData = this.solContentData.filter((v) => v.id != id);
    },
    //添加合约参数
    addFunParams() {
      this.contractForm.contractFuncVoList.push({
        id: shortid.generate(),
        funcName: "",
        type: "",
        funcParam: "",
        funcOutParam: "",
      });
    },
    delFunParams(id) {
      const data = this.contractForm.contractFuncVoList.filter(
        (v) => v.id != id
      );
      this.contractForm.contractFuncVoList = data;
    },
    //提交
    submitConTem() {
      let flag = true;
      if (this.fileType == 1) {
        let obj = {};

        for (let item of this.solContentData) {
          //ab文件不需要Main.sol
          // if (item.name == "Main.sol") {
          //   flag = true;
          // }
          obj[item.name] = item.content;
        }
        obj = JSON.stringify(obj);
        this.contractForm.solContent = obj;
        this.contractForm.abiJson = ""; //置空abi
      } else if (this.fileType == 2) {
        //转换abi结构
        this.contractForm.abiJson = JSON.stringify({
          abi: this.contractForm.abiJson,
        });
        this.contractForm.solContent = ""; //置空源代码
      }

      for (let key in this.contractForm) {
        // console.log(this.contractForm[key], key, 999999999);
        if (key != "contractFuncVoList" && key != "publicFlag" && key != "id") {
          this.contractForm[key] = this.contractForm[key].replace(/，/g, ",");
        } else {
          this.contractForm.contractFuncVoList.forEach((v) => {
            if (this.type != 2) {
              v.id = "";
            }
            for (let keys in v) {
              // let {...item, id }
              // v = item
              if (keys != "type" && keys != "id") {
                v[keys] = v[keys].replace(/，/g, ",");
              }
            }
          });
        }
      }

      console.log(this.contractForm, 9696996);
      this.dialogVisible = false;
      if (this.fileType == 2 || flag) {
        //添加
        if (this.type == 1) {
          this.addContracts();
        } else {
          //编辑
          this.updateContracts();
        }
      } else {
        this.$message.error("合约文件必须有Main.sol!");
      }
    },
    // //合约模板切换时
    contractChange() {
      const data = this.optionConTem.find((v) => v.id == this.selectConTem);
      this.constructorParam = data.constructorParam.replace(/  */g, " ");
    },
    //添加合约
    addContracts() {
      addContract(this.contractForm).then((res) => {
        if (res.code == 200) {
          this.$message.success(res.msg);
          this.getContractList();
          this.handleClose();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    //修改合约
    updateContracts() {
      updateContract(this.contractForm).then((res) => {
        if (res.code == 200) {
          this.$message.success(res.msg);
          this.getContractList();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    handleClose() {
      this.dialogVisible = false;
      this.solContentData = [
        {
          id: 0,
          name: "",
          content: "",
        },
      ];
      //恢复默认
      this.contractForm = {
        publicFlag: false,
        contractJson: "{}",
        name: "",
        description: "",
        version: "",
        constructorParam: "",
        solContent: "",
        contractFuncVoList: [
          {
            id: 0,
            funcName: "transfer",
            type: 1,
            funcParam: "address:account",
            funcOutParam: "",
          },
        ],
      };
    },
    currentPageChange(e) {
      this.currentPage = e;
      this.searAdd();
    },
  },

  computed: {
    ...mapState({
      roles: (state) => state.app.roles,
    }),
  },
  created() {
    this.getData();
  },
};
</script>
<style scoped>
.user_all {
  padding: 20px 30px;
}

.user_search {
  margin-bottom: 30px;
}
</style>
